import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker, faPython } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "React",
    "Typescript",
    "Node.js",
    "Express",
    "Java",
    "Spring Boot",
    "mySQL",
    "MongoDB",
    "Rust"
];

const labelsSecond = [
    "Git",
    "GitHub Actions",
    "Docker",
    "AWS",
    "Linux",
    "BSD",
    "Kubernetes",
    "KVM",

];

const labelsThird = [
    "OpenAI",
    "Groq",
    "Anthropic",
];

const labelsFourth = [
    "Stripe",
    "Plaid",
    "Twilio",
    "SendGrid",
    "Firebase",
    "Salesforce",
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faReact} size="3x"/>
                    <h3>Full Stack Web Development</h3>
                    <p>I have built a large array of web applications from scratch using modern technologies such as React and Flask. I have also designed robust backend systems using Node.js, Rust, and Spring Boot.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label) => (
                            <Chip key={label} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDocker} size="3x"/>
                    <h3>DevOps & Automation</h3>
                    <p>Once the application is built, I help clients deploy and maintain it in production. I have experience with a variety of tools such as Docker, Kubernetes, AWS, and GitHub Actions to ensure smooth deployments and efficient CI/CD pipelines.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label) => (
                            <Chip key={label} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faPython} size="3x"/>
                    <h3>GenAI & LLM</h3>
                    <p>Stay relevant in the market by leveraging the latest AI models in your projects. I have professional experience building AI chatbots and GenAI-enabled solutions to empower intelligent decision making.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label) => (
                            <Chip key={label} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                 <div className="skill">
                    <FontAwesomeIcon icon={faPython} size="3x"/>
                    <h3>Integrations</h3>
                    <p>I have integrated a wide variety of third party APIs in my projects, including payment processors, CRMs, communication tools, and more. I can help you leverage the power of these platforms to enhance your application's functionality.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFourth.map((label) => (
                            <Chip key={label} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;